import { Box } from "@mui/material";
import React from "react";

const ResponseStatusBadge = ({ status }) => {
  if (status) {
    return (
      <Box
        borderRadius={5}
        border="1px solid #6EADFC"
        bgcolor="#E1F5FF"
        color="#3E399B"
        px={2}
        py={1}
        textAlign="center"
      >
        200
      </Box>
    );
  }

  return (
    <Box
      borderRadius={5}
      border="1px solid #FCA5A5"
      bgcolor="#FEF2F2"
      color="#FCA5A5"
      px={2}
      py={1}
      textAlign="center"
    >
      500
    </Box>
  );
};

export const RequestMethodsBadge = ({ method }) => {
  if (method === "POST") {
    return (
      <Box
        borderRadius={5}
        border="1px solid #C4B5FD"
        bgcolor="#F5F3FF"
        color="#C4B5FD"
        px={2}
        py={1}
        textAlign="center"
      >
        {method}
      </Box>
    );
  }

  if (method === "DELETE") {
    return (
      <Box
        borderRadius={5}
        border="1px solid #FCA5A5"
        bgcolor="#FEF2F2"
        color="#FCA5A5"
        px={2}
        py={1}
        textAlign="center"
      >
        {method}
      </Box>
    );
  }

  if (method === "GET") {
    return (
      <Box
        borderRadius={5}
        border="1px solid #6EADFC"
        bgcolor="#E1F5FF"
        color="#6EADFC"
        px={2}
        py={1}
        textAlign="center"
      >
        {method}
      </Box>
    );
  }

  return (
    <Box
      borderRadius={5}
      border="1px solid #FFBC5D"
      bgcolor="#FFF4E6"
      color="#FFBC5D"
      px={2}
      py={1}
      textAlign="center"
    >
      {method}
    </Box>
  );
};

export const NotificationStatusBadge = ({ status }) => {
  if (status === "SENT") {
    return (
      <Box
        borderRadius={5}
        border="1px solid #6EE7B7"
        bgcolor="#ECFDF5"
        color="#059669"
        px={2}
        py={1}
        textAlign="center"
      >
        {status}
      </Box>
    );
  }

  if (status === "REJECTED") {
    return (
      <Box
        borderRadius={5}
        border="1px solid #FCA5A5"
        bgcolor="#FEF2F2"
        color="#FCA5A5"
        px={2}
        py={1}
        textAlign="center"
      >
        {status}
      </Box>
    );
  }

  return null;
};

export default ResponseStatusBadge;
